export default __webpack_public_path__ + "static/media/insurance.a626b16f.svg";